import { StarIcon } from '@chakra-ui/icons';
import { Avatar, Box, Button, chakra, ButtonGroup, Flex, HStack, VStack, WrapItem, Text } from '@chakra-ui/react';
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Formik } from 'formik';

import Loading from 'components/Loading';
import { AccountContext } from '../../../AccountContext';
import BottomNavBar from 'components/BottomNavBar';
import ChildHeader from '../ChildHeader';
import SelectField from 'components/SelectField';
import NoUserHeader from 'components/AreaLivre/NoUserHeader';

function EscolhaProcedimento() {
  const navigate = useNavigate();
  const { user, setPage } = useContext(AccountContext);
  const { state } = useLocation();
  const { medico, avaliacao } = state;
  const dadosMedico = medico.dados;
  const horarios = medico.horarios;
  const [agendas, setAgendas] = useState([]);
  const [procedimento, setProcedimento] = useState(null);
  const [disabled, setDisabled] = useState(true);

  const profilePic = `${process.env.REACT_APP_URL_FOTO_OPERADOR}/${dadosMedico.medico}`;

  let namesArray = typeof dadosMedico.nome === 'string' ? dadosMedico?.nome?.split(' ') : [''];
  namesArray = namesArray.filter((name) => !['da', 'das', 'do', 'dos', 'de', 'des', 'e'].includes(name.toLowerCase()));
  const nomeMedico = namesArray.length < 2 ? namesArray[0] : `${namesArray[0]} ${namesArray[1]}`;

  let titulo = 'Dr(a).';
  if (dadosMedico.sexo === 'M') {
    titulo = 'Dr.';
  } else if (dadosMedico.sexo === 'F') {
    titulo = 'Dra.';
  }

  const sexo = user?.loggedIn ? (user.sexo === 'M' || user.sexo === 'm' ? 'M' : user.sexo === 'F' || user.sexo === 'f' ? 'F' : '') : null;

  let procedimentos = [];
  let nomesProcedimentos = [];
  horarios.forEach((horario) => {
    horario.procedimentos.forEach((procedimento) => {
      if (!user?.loggedIn || (user?.loggedIn && !user?.sexo)) {
        if (nomesProcedimentos.includes(procedimento.nome) === false) {
          procedimentos.push(procedimento);
          nomesProcedimentos.push(procedimento.nome);
        }
        return;
      }
      if (procedimento?.restricao_sexo === sexo || procedimento.restricao_sexo === 'A' || procedimento?.restricao_sexo === null) {
        if (nomesProcedimentos.includes(procedimento.nome) === false) {
          procedimentos.push(procedimento);
          nomesProcedimentos.push(procedimento.nome);
        }
      }
    });
  });

  const valorProcedimento = procedimento !== null ? procedimentos[procedimento]?.valor : 0;

  setPage('Escolha o procedimento');

  const renderAvaliacao = (avaliacao_media) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <StarIcon
          key={i}
          color={avaliacao_media >= i || avaliacao_media === 0 || avaliacao_media === '0' || !avaliacao_media ? 'orange' : 'gray.500'}
        />
      );
    }
    return stars;
  };

  function Profile() {
    return (
      <Flex minW="320px" maxW="320px" mx="auto" bg="" overflow="hidden">
        <Box w={1 / 3} bgSize="cover" align="center">
          <WrapItem ml="5px" mt="0.8em">
            <Avatar id={dadosMedico.medico_id} size="xl" name={dadosMedico.nome} src={profilePic} />
          </WrapItem>
          <chakra.a
            color="rgba(14, 170, 139, 1)"
            fontWeight="bold"
            fontSize="sm"
            onClick={() => navigate('/empresa/medico/curriculo', { state: { medico, avaliacao } })}
          >
            ver curriculo
          </chakra.a>
        </Box>
        <Box w={2 / 3} p={{ base: 4, md: 4 }} marginBottom="5%">
          <chakra.h2 fontSize="xl" fontWeight="bold">
            <Text casing="capitalize">{`${titulo} ${nomeMedico.toLowerCase()}`}</Text>
          </chakra.h2>
          <chakra.p fontSize="md">{dadosMedico.especialidade}</chakra.p>
          <chakra.p fontSize="sm">{dadosMedico.conselho}</chakra.p>
          <HStack spacing={1} display="flex" alignItems="center" fontSize="sm" pt={0.5}>
            {renderAvaliacao(
              !avaliacao || avaliacao?.avaliacao_media === '0' ? '5' : avaliacao.avaliacao_media >= 1 ? Math.round(avaliacao.avaliacao_media) : '5'
            )}
            <chakra.span fontSize="xs"></chakra.span>
          </HStack>
        </Box>
      </Flex>
    );
  }

  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  const colorButton = usuarioAssinante ? '#5AB2AE' : '#5AB2AE';

  return (
    <>
      {user.loggedIn === true ? <ChildHeader /> : <NoUserHeader />}
      <Formik initialValues={{ empresa: 0, dependente: 0 }} validateOnChange={false} validateOnBlur={false}>
        <VStack w={{ base: '90%', md: '500px' }} m="auto" justify="center" spacing="10">
          <Profile />
          <SelectField
            name="procedimento"
            label="Escolha o procedimento: "
            w="95%"
            h={50}
            variant="outline"
            borderWidth={2}
            options={nomesProcedimentos}
            onChange={(value) => {
              setProcedimento(parseInt(value));
              setDisabled(false);
            }}
          />

          <ButtonGroup pt="1rem" pb="25%" width="100%">
            <Button
              w="100%"
              colorScheme="teal"
              bg={colorButton}
              onClick={() =>
                navigate('/atendimento/agendamento', {
                  state: {
                    ...state,
                    procedimentoId: procedimentos[procedimento].id,
                    procedimento: procedimentos[procedimento].nome,
                    price: valorProcedimento,
                    procedimentoParticular:
                      procedimentos &&
                      procedimentos.length > 0 &&
                      procedimentos[procedimento].procedimento_particular &&
                      procedimentos[procedimento].procedimento_particular.length > 0
                        ? procedimentos[procedimento].procedimento_particular.particular_id
                        : null,
                    valorParticular:
                      procedimentos &&
                      procedimentos.length > 0 &&
                      procedimentos[procedimento].procedimento_particular &&
                      procedimentos[procedimento].procedimento_particular.length > 0
                        ? procedimentos[procedimento].procedimento_particular.valor
                        : null,
                  },
                })
              }
              disabled={disabled}
            >
              Continuar
            </Button>
          </ButtonGroup>
        </VStack>
      </Formik>
      <BottomNavBar />
    </>
  );
}

export default EscolhaProcedimento;
